// Kept apart from ./saveRelationships so reading a sentinel does not pull in the dispatch builder.

/** Record id standing in for a record that does not exist yet. */
export const MAKE_NEW_RECORD = 'MAKE_NEW_RECORD_ID'

/** Base key for "no relationship recorded between these two people". */
export const NO_RELATION_KEY = 'NO_RELATION'

/** Selecting this stores nothing and clears any existing relationship. */
export const NO_RELATION_TYPE = `${NO_RELATION_KEY}_FIRST`
